import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Category } from '@core/model/category.model';
import { CategoryService } from '@app/core';
import Swal from 'sweetalert2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-category-create',
  templateUrl: './category-create.component.html',
  styleUrls: ['./category-create.component.css']
})
export class CategoryCreateComponent implements OnInit {
  categoryForm: FormGroup;
  categories: Category[];
  Category: any = {};
  isLoading = false;
  // estado: boolean;
  idCategory: string;
  @Input() category2_id: string;
  @Input() estado: boolean;
  @Input() titulo: string;
  constructor(
    private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    // this.listCategories();
    // this.categoryForm=this.category2;
    // console.log(this.category2);
    // this.editCategory();
    this.createForm();
    const id = this.category2_id;

    // console.log(id);
    if (this.estado === true) {
      this.categoryService.getById(id).subscribe(data => {
        // console.log(data);
        // this.categoryForm.setValue(data);
        this.categoryForm.setValue({
          nombre: data.nombre,
          descripcion: data.descripcion
        });
      });
    }
  }

  createForm() {
    this.categoryForm = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  listCategories() {
    this.categoryService.getAll().subscribe(
      data => {
        this.categories = data;
        //  console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerCategory() {
    this.idCategory = this.category2_id;
    // console.log(this.categoryForm.value);
    this.Category.nombre = this.categoryForm.value.nombre;
    this.Category.descripcion = this.categoryForm.value.descripcion;
    //  console.log(this.Category);
    if (this.estado === true) {
      this.categoryService.update(this.idCategory, this.Category).subscribe(
        data => {
          Swal.fire(data);
          // this.listCategories();
          this.categoryForm.reset();
          this.estado = false;
          this.activeModal.close(data);
        },
        error1 => {
          Swal.fire(error1.error);
        }
      );
    } else {
      this.categoryService.create(this.Category).subscribe(
        data => {
          // alert('Fue creado satisfactoriamente');
          Swal.fire(data);
          this.categoryForm.reset();
          this.activeModal.close(data);
        },
        error => {
          Swal.fire(error.error);
        }
      );
    }
  }

  enableCategory(id: number) {
    this.categoryService.enableCategory(id).subscribe(
      data => {
        this.listCategories();
      },
      error => {
        console.log(error.error);
      }
    );
  }

  editCategory() {
    // this.idCategory = categoria_id;
    this.estado = true;
    this.categoryService.getById(this.category2_id).subscribe(
      data => {
        // console.log(data);
        this.categoryForm.setValue({
          nombre: data.nombre,
          descripcion: data.descripcion
        });
      },
      error1 => console.log(error1)
    );
  }
}
